import { FloatTooltipContent } from './FloatTooltipContent';
import { FloatTooltipRoot } from './FloatTooltipRoot';
import { FloatTooltipTrigger } from './FloatTooltipTrigger';

export const FloatTooltip = {
  Root: FloatTooltipRoot,
  Trigger: FloatTooltipTrigger,
  Content: FloatTooltipContent
};
